import React, { Component } from "react";
import DeviceSearch from './DeviceSearch'
import AddDeviceModalComponent from "./AddDeviceModal";
import { deviceMessages } from '../../helpers/messages';

export default class DeviceMessage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSuccessMsg: ''
        }
    }
    /**
     * @description Funtion to handle situation when device added
     * @memberof DeviceComponent
     */
    /* istanbul ignore next  */
    deviceAdded = () => {
        this.setState({ showSuccessMsg: deviceMessages.deviceSaved })
        this.props.deviceAdded(true);
        setTimeout(() => {
            this.setState({ showSuccessMsg: '' });
        }, 5000);
    }

    render() {
        const { fromDashboard, handleSearchSubmit, handleReset, filterActiveDevice } = this.props;
        const { showSuccessMsg } = this.state;
        return (
            <div className="row">
                <div className="col-6" data-testid="deviceMessage">
                    <DeviceSearch handleSearchSubmit={handleSearchSubmit} handleReset={handleReset} />
                </div>
                <div className="col-4">
                    <div className="d-flex align-items-center pt-3">
                        <label className="me-2">Active Devices Only</label>
                        <label className="switch active-users-filter">
                            <input onChange={(e) => filterActiveDevice(e.target.checked)} type="checkbox" defaultChecked={true} data-testid="filterDeviceToggle"/>
                            <div className="slider round">
                                <span className="on">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-power" viewBox="0 0 16 16">
                                        <path d="M7.5 1v7h1V1h-1z" />
                                        <path d="M3 8.812a4.999 4.999 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812z" />
                                    </svg>
                                </span>
                                <span className="off">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ccc" className="bi bi-power" viewBox="0 0 16 16">
                                        <path d="M7.5 1v7h1V1h-1z" />
                                        <path d="M3 8.812a4.999 4.999 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812z" />
                                    </svg>
                                </span>
                            </div>
                        </label>
                    </div>
                </div>
                <div className="col-2 text-end">
                    <div className="pt-3">
                        <AddDeviceModalComponent deviceAdded={this.deviceAdded} fromDashboard={fromDashboard} />
                    </div>
                </div>
                <div className="col-md-12">
                    {showSuccessMsg ? <div className="proms-success-msg my-3">{showSuccessMsg}</div> : ''}
                </div>
            </div>

        );
    }
}
